module.exports = __webpack_public_path__ + "img/share-grey.bf236294.svg";